// extracted by mini-css-extract-plugin
export var textInput = "_la-0";